import React from "react";
import ConceptPageComponent from "../components/concept/index";

const ConceptPage = () => {
  return (
    <>
      <ConceptPageComponent />
    </>
  );
};

export default ConceptPage;
